import styled from 'styled-components';

export const HeadingContainer = styled.div<{ changePassword: boolean }>`
  height: ${(props) => (props.changePassword ? '50px' : '100px')};
  margin-top: ${(props) => (props.changePassword ? '10px' : '0')};
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.changePassword ? 'row' : 'column')};
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  justify-content: flex-start;
  align-items: center;
`;

export const OpenReportHeading = styled.h2`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.newPalette.neutral.N800};
  height: 50px;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  margin: 0;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    margin: -80px;
  }
`;

export const InfoContainer = styled.div<{ changePassword: boolean }>`
  margin-bottom: ${(props) => (props.changePassword ? '30px' : '20px')};
  margin-top: ${(props) => (props.changePassword ? '15px' : '-10px')};
  display: flex;
  align-items: center;
  width: 100%;
`;

export const PasswordSectionTitle = styled.p`
  margin: 0;
  font-size: 14px;
`;

export const CurrentPasswordContainer = styled.div`
  margin-bottom: 30px;
`;
